import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminSidebar from "./AdminCommon/AdminSidebar";
import AdminHeader from "./AdminCommon/AdminHeader";
import "./Admin.css";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
import { Popover, OverlayTrigger, Button } from "react-bootstrap";
import {
  contactUsList,
  cancelActionInLeadList,
  closeActionInLeadList,
  rejectActionInLeadList,
  forwardActionInLeadList,
//  getSingleLead
} from "../../redux/Admin/actions/userAction/userAction";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import Alert from "../Common/Alert";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import FilterComponent from "./AdminCommon/FilterComponent";
import * as constantMessages from "../../constants/constatntMessages";

//// added by Monalisa ///////////////////////////
import Dropdown from "react-bootstrap/Dropdown";
import LeadDropDown from "./LeadDropDown";
import CommonModal from "../Common/CommonModal";
import ReassignModal from "./ReassignModal";
import CancelLeadModal from "./CancelLeadModal";
import CloseLeadModal from "./CloseLeadModal";
import ViewLeadModal from "./ViewLeadModal";
import { logOut } from "../../redux/Admin/actions/adminAuthActions/authAction";
//// ///////////////////////////

const regularExpression = /^[0-9a-zA-Z -.(),-,_@/]+$/;
function Leads() {
  const location = useLocation();
  console.log(location);
  const { paramDatas } = location.state || {};
  console.log(paramDatas);

  const userData = JSON.parse(localStorage.getItem("userData"));
  console.log('User Daattaaa', userData)

  const accessToken = localStorage.getItem("accessToken");
  console.log('Access Token', accessToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authData = useSelector((state) => state.adminauth);
  console.log(authData)

  const actionData = useSelector((state) => state.action);
  console.log('actionData----', actionData)

  const [filter, setFilter] = useState(false);
  const contactList = useSelector((state) => state.adminuser) || [];
  console.log("redux data", contactList);
  console.log(contactList.contactList);

  const singleLeadData = useSelector((state) => state.adminuser.singleLeadData);
  console.log('Single Lead Data in Leadjs', singleLeadData)

  const totalCount = contactList.totalCount;
  console.log("Total Count:", totalCount);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    console.log("Updated Redux State (After Filter Apply):", contactList);
  }, [contactList]);

  const leadsData = Array.isArray(contactList?.contactList)
    ? contactList.contactList
    : [];
  console.log("Leads Data:", leadsData);

  const [searchData, setSearchData] = useState({
    searchKey: "",
    page: 1,
    limit: 5,
    order: -1,
    filterData: {},
  });

  //// added by Monalisa ///////////////////////////

  if (authData.isInValidUser) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/admin-login");
  }

  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false); // common modal
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [leadId, setleadId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [isCloseActionModalOpen, setIsCloseActionModalOpen] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [leadDatas, setLeadDatas] = useState(null);
  const [isviewLeadModalOpen, setIsViewLeadModalOpen] = useState(false);


  //// ///////////////////////////

  // useEffect(()=>{
  //   alert("In leads")
  // })

  useEffect(() => {
    document.title = "Admin Lead: MinutesVault";
    const payload = {
      page: searchData.page,
      order: searchData.order,
      limit: searchData.limit,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      accessToken,
    };
    if (searchData.searchKey !== "") {
      payload["searchKey"] = searchData.searchKey;
    }
    if (searchData.filterData.page === 1) {
      payload["searchKey"] = searchData.searchKey;
      setSearchData({
        ...searchData,
        page: 1,
      });
      payload.page = 1;
    }
    if (searchData.searchKey.trim()) {
      const errors = {};
      if (!regularExpression.test(searchData.searchKey)) {
        errors.searchKey = constantMessages.titleRegexError;
        setErrors(errors);
      } else {
        setErrors({});
        dispatch(contactUsList(payload));
      }
    } else {
      setErrors({});
      dispatch(contactUsList(payload));
    }
  }, [
    //  searchData.searchKey,
    searchData.order,
    searchData.page,
    searchData.limit,
    searchData.filterData,
  ]);

  useEffect(() => {
    //alert(6)
    if (searchData.searchKey !== "") {
      //   alert(2)

      const payload = {
        page: 1,
        order: searchData.order,
        limit: searchData.limit,
        toDate: searchData.filterData?.toDate,
        fromDate: searchData.filterData?.fromDate,
        accessToken,
      };

      if (searchData.searchKey !== "") {
        payload["searchKey"] = searchData.searchKey;
        setSearchData({
          ...searchData,
          page: 1,
        });
        payload.page = 1;
      }
      if (searchData.filterData.page === 1) {
        payload["searchKey"] = searchData.searchKey;
        setSearchData({
          ...searchData,
          page: 1,
        });
        payload.page = 1;
      }

      if (searchData.searchKey.trim()) {
        const errors = {};
        if (!regularExpression.test(searchData.searchKey)) {
          // alert("in error")
          errors.searchKey = constantMessages.titleRegexError;
          setErrors(errors);
        } else {
          setErrors({});
          dispatch(contactUsList(payload));
        }
      } else {
        setErrors({});
        dispatch(contactUsList(payload));
      }
    } else {
      // alert(5)
      setSearchData({
        ...searchData,
        page: 1,
      });
    }
  }, [searchData.searchKey]);
  const filterData = (data) => {
    setSearchData((prev) => ({
      ...prev,
      filterData: data,
      page: 1,
    }));
  };

  const handlePageChange = (event, value) => {
    // alert(1);
    setSearchData((prev) => ({
      ...prev,
      page: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prev) => ({
      ...prev,
      [name]: value,
    }));
    const newPayload = {
      page: 1,
      order: searchData.order,
      limit: searchData.limit,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      accessToken,
    };

    if (value.trim() !== "") {
      newPayload["searchKey"] = value;
    }

    if (value.trim() === "") {
      dispatch(contactUsList(newPayload));
    }
  };

  const totalOption =
    totalCount && totalCount % 5 === 0
      ? Math.round(contactList.totalCount / 5)
      : totalCount && totalCount % 5 !== 0
        ? Math.round(totalCount / 5 + 0.5)
        : 0;
  const checkTotalPage =
    totalCount % searchData.limit === 0
      ? Math.round(totalCount / searchData.limit)
      : Math.round(totalCount / searchData.limit + 0.5);
  const totalPage = totalCount ? checkTotalPage : 0;

  console.log(totalPage);

  const totalPageArray = Array(totalPage).fill();
  console.log(totalPageArray);
  let modifiedArray = [];
  totalPageArray.map((item, index) => {
    if (
      index === searchData.page - 1 ||
      (index <= searchData.page + 3 && index >= searchData.page)
    ) {
      modifiedArray.push(index);
    }
    return item;
  });
  console.log(modifiedArray);
  const fromDataCount =
    contactList.length === 0 ? 0 : (searchData.page - 1) * searchData.limit + 1;
  const toDataCount =
    (searchData.page - 1) * searchData.limit + leadsData.length;

  useEffect(() => {
    console.log("Current Page:", searchData.page, "Limit:", searchData.limit);
  }, [searchData.page, searchData.limit]);

  const renderPopover = (message) => (
    <Popover id="popover-message">
      <Popover.Body>{message}</Popover.Body>
    </Popover>
  );

  //  Open CancelLeadModal
  const submitCancelAction = (leadId) => {
    setleadId(leadId);
    setIsCancelModalOpen(true);
  };

  // After submitting reason, close CancelLeadModal & open CommonModal
  const handleCancelLeadSubmit = (reason) => {
    setCancelReason(reason);
    setIsCancelModalOpen(false);
    setTimeout(() => {
      setIsCloseModalOpen(true);
    }, 300);
  };

  // Final API call after confirming in CommonModal
  const handleCancelLead = () => {
    console.log("LeadsId----", leadId);
    const payload = { reason: cancelReason };
    dispatch(cancelActionInLeadList(leadId, payload, searchData, accessToken));
    setleadId(null);
    setIsCloseModalOpen(false);
  };

  // open close lead modal
  const handleCloseActionModal = (leadId) => {
    console.log("Id in handle close action", leadId);
    setleadId(leadId);
    setActionType("close");
    setIsCloseActionModalOpen(true);
  };
  // submit close lead modal
  const submitCloseAction = (leadId, reason) => {
    console.log("Id in submit close action", leadId);
    console.log("Reason in submit close action", reason);
    dispatch(closeActionInLeadList(leadId, { reason }, searchData, accessToken));
    setleadId(null);
    setIsCloseActionModalOpen(false);
  };

  // open for reject modal
  const handleRejectActionModal = (leadId) => {
    console.log("Id in handle reject action", leadId);
    setleadId(leadId);
    setActionType("reject");
    setIsCloseActionModalOpen(true);
  };

  //submit reject action
  const submitRejectAction = (leadId, reason) => {
    console.log("Id in submit close action", leadId);
    console.log("Reason in submit close action", reason);
    dispatch(rejectActionInLeadList(leadId, { reason }, searchData, accessToken));
    setleadId(null);
    setIsCloseActionModalOpen(false);
  };

  // action forward modal
  const handleReassignModal = (item) => {
    setleadId(item._id);
    setLeadDatas(item);
    setIsReassignModalOpen(true);
  };

  // forward lead
  const handleReassign = (data) => {
    dispatch(
      forwardActionInLeadList(
        leadId,
        {
          forwardedTo: data.forwardedTo,
          reason: data.reason,
        },
        searchData,
        accessToken
      )
    );
    setleadId(null);
    setIsReassignModalOpen(false);
  };

  // view single lead
  const handleViewLeadModal = (leadId) => {
    //dispatch(getSingleLead(leadId, accessToken))
    setIsViewLeadModalOpen(true);
  }

  return (
    <>
      <AdminHeader />
      <AdminSidebar />

      <div className="main-content">
        <div className="meeting-header-text">
          <h4>Leads</h4>
        </div>
        <FilterComponent
          setfilter={setFilter}
          filterData={filterData}
          initData={searchData.filterData}
          filter={filter}
        />
        <div className="mt-2 table-box responsive-table">
          <div className="d-flex align-items-center justify-content-between resp-flex-column">
            <div className="left-tbl-text">
              {totalCount > 0 ? (
                <p>
                  Showing {fromDataCount || 0} to {toDataCount || 0} of{" "}
                  {totalCount} entries
                </p>
              ) : null}
            </div>
            <div className="meeting-f-search">
              <div className="search-box d-flex align-items-center">
                <input
                  type="search"
                  placeholder="Search By Name / Email / Mobile Number"
                  name="searchKey"
                  onChange={handleChange}
                  value={searchData.searchKey}
                  autoComplete="off"
                />

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#4F2CC8"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </div>
              <button
                className="btn add-btn Mom-btn d-flex align-items-center justify-content-center"
                id="open-form-btn"
                onClick={(e) => setFilter(true)}
              >
                <p>Filter</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-funnel filter-svg"
                  viewBox="0 0 16 16"
                >
                  <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
                </svg>
              </button>
            </div>
          </div>

          {!contactList.loading &&
            contactList?.length !== 0 &&
            contactList.isSuccess ? (
            <table className="mt-4 table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sl.No</th>
                  <th>Name</th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                  <th>Message</th>
                  <th className="status-align-center">Status</th>
                  <th className="status-align-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                {leadsData.map((item, index) => {
                  console.log("Item in table rendering:", item);
                  return (
                    <tr key={item._id}>
                      <td data-label="Sl.No">
                        {(searchData.page - 1) * searchData.limit + index + 1}
                      </td>
                      <td data-label="Name">{item.name}</td>
                      <td data-label="Mobile Number">{item.phoneNo}</td>
                      <td data-label="Email">{item.email}</td>
                      <td data-label="Message">
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          placement="bottom"
                          overlay={renderPopover(item.message)}
                        >
                          <span className="message-preview">
                            {item.message.length > 35
                              ? `${item.message.slice(0, 35)}...`
                              : item.message}
                          </span>
                        </OverlayTrigger>
                      </td>
                      <td
                        data-label="Status"
                        className="meeting-td-width-5  text-align-center"
                      >
                        <span
                          className={
                            item?.leadStatus?.status === "closed"
                              ? "badge  bg-opacity-10 closed-color"
                              : item?.leadStatus?.status === "rejected"
                                ? "badge  bg-opacity-10 canceled-color"
                                : item?.leadStatus?.status === "cancelled"
                                  ? "badge  bg-opacity-10 canceled-color"
                                  : item?.leadStatus?.status === "forwarded"
                                    ? "badge forwardrequested-color bg-opacity-10"
                                    : "badge pending-color bg-opacity-10"
                          }
                        >
                          {item?.leadStatus?.status.charAt(0).toUpperCase() +
                            item?.leadStatus?.status?.slice(1)}
                        </span>
                      </td>
                      <td
                        data-label="Action"
                        className="text-align-center meeting-td-width-7"
                      >
                        <div className="d-inline-block menu-dropdown custom-dropdown">
                          <div className="d-inline-block menu-dropdown custom-dropdown">
                            <Dropdown>
                              <LeadDropDown
                                LeadDetails={item}
                                leadId={item?._id}
                                handleViewLeadModal={() => {
                                  handleViewLeadModal(item?._id);
                                }}
                                handleReassignModal={() => {
                                  handleReassignModal(item);
                                }}
                                handleCloseActionModal={(leadId) => {
                                  handleCloseActionModal(item?._id);
                                }}
                                handleRejectActionModal={(leadId) => {
                                  handleRejectActionModal(item?._id);
                                }}
                                handleCancelActionModal={(leadId) => {
                                  submitCancelAction(item?._id);
                                }}
                              />
                            </Dropdown>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : !contactList.loading && (!leadsData || leadsData.length === 0) ? (
            <div className="no-data-img">
              <Alert
                status={"info"}
                message={"No data available."}
                timeoutSeconds={0}
              />
              <NoDataFound dataType={"meeting"} />
              <Button
                className="mt-2"
                variant="primary"
                onClick={(e) => {
                  setSearchData({
                    ...searchData,
                    searchKey: "",
                    filterData: {},
                    page: 1,
                  });
                }}
              >
                Clear
              </Button>
            </div>
          ) : (
            <div
              className="meeting-page "
              style={{ textAlign: "center", paddingTop: 20 }}
            >
              <Loader />
            </div>
          )}

          {totalCount <= 1 ? null : (
            <div className="tbl-bottom">
              <div className="left-tbl-bottom">
                {searchData.page !== 1 ? (
                  <button
                    className="left-arrow"
                    onClick={(e) =>
                      setSearchData({
                        ...searchData,
                        page: searchData.page - 1,
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#fff"
                      className="bi bi-chevron-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                      />
                    </svg>
                  </button>
                ) : null}

                <Stack spacing={2}>
                  <Pagination
                    count={totalPage}
                    page={searchData.page}
                    siblingCount={0}
                    boundaryCount={2}
                    onChange={handlePageChange}
                    hidePrevButton
                    hideNextButton
                    sx={{
                      "& .Mui-selected": {
                        backgroundColor: "#388d27 !important",
                        color: "#fff !important",
                      },
                    }}
                  />
                </Stack>
                {totalPageArray?.length !== searchData.page ? (
                  <button
                    className="right-arrow"
                    onClick={(e) =>
                      setSearchData({
                        ...searchData,
                        page: searchData.page + 1,
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#fff"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                      />
                    </svg>
                  </button>
                ) : null}
              </div>

              <div className="right-tbl-bottom">
                <p>Rows Per Page</p>
                <select
                  className="no-opt-box"
                  name="limit"
                  onChange={(e) =>
                    setSearchData({
                      ...searchData,
                      page: 1,
                      limit: e.target.value,
                    })
                  }
                  value={searchData.limit}
                >
                  {totalOption &&
                    Array(totalOption)
                      .fill()
                      .map((_, option) => {
                        return (
                          <option value={(option + 1) * 5}>
                            {(option + 1) * 5}
                          </option>
                        );
                      })}
                </select>
              </div>
            </div>
          )}
        </div>

        <ViewLeadModal
          setIsModalOpen={setIsViewLeadModalOpen}
          isModalOpen={isviewLeadModalOpen}
          singleLeadData={singleLeadData}
        />

        <ReassignModal
          setIsReassignModalOpen={setIsReassignModalOpen}
          isModalOpen={isReassignModalOpen}
          handleSubmit={handleReassign}
          actionData={leadDatas}
        />
        {/* <CancelLeadModal
          setIsModalOpen={setIsCancelModalOpen}
          isModalOpen={isCancelModalOpen}
          handleSubmit={handleCancelLeadSubmit}
        /> */}
        <CloseLeadModal
          setIsModalOpen={setIsCloseActionModalOpen}
          isModalOpen={isCloseActionModalOpen}
          actionType={actionType}
          handleSubmit={(reason) => {
            if (actionType === "close") {
              submitCloseAction(leadId, reason);
            } else if (actionType === "reject") {
              submitRejectAction(leadId, reason);
            }
          }}
        />
      </div>
      <CommonModal
        message={"Do you want to cancel the Lead ?"}
        title={"Cancel Lead"}
        setIsModalOpen={setIsCloseModalOpen}
        isModalOpen={isCloseModalOpen}
        handleSubmit={handleCancelLead}
        buttonName={"Cancel"}
        isCalledFromOthers={true}
      />
    </>
  );
}

export default Leads;
